// extracted by mini-css-extract-plugin
export var activeDot = "_61-c";
export var buttonContainer = "_61-9";
export var channelButton = "_61-a";
export var clickable = "_61-d";
export var content = "_61-0";
export var contentFull = "_61-2";
export var contentThird = "_61-1";
export var contentWrapper = "_61-7";
export var description = "_61-5";
export var heightShort = "_61-f";
export var image = "_61-3";
export var imageContainer = "_61-4";
export var selectButton = "_61-e";
export var spinnerContainer = "_61-b";
export var titleContent = "_61-8";
export var titleWrapper = "_61-6";